module.exports = __webpack_public_path__ + "img/154.3477c0c9.jpg";